// client/src/components/EquityGraph.js

import React from "react";
import {
  ResponsiveContainer,
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  CartesianGrid,
} from "recharts";

export default function EquityGraph({ data }) {
  if (!data || data.length === 0) return null;

  return (
    <div className="w-full" style={{ height: 300 }}>
      <ResponsiveContainer>
        <LineChart
          data={data}
          margin={{ top: 20, right: 30, left: 0, bottom: 10 }}
        >
          <CartesianGrid strokeDasharray="3 3" stroke="#e0e0e0" />

          <XAxis
            dataKey="month"
            stroke="#333"
            tick={{ fontSize: 12 }}
          />

          <YAxis
            stroke="#333"
            tick={{ fontSize: 12 }}
          />

          <Tooltip
            contentStyle={{
              backgroundColor: "white",
              border: "1px solid #ddd",
              borderRadius: "6px",
            }}
            labelStyle={{ fontWeight: "bold" }}
          />

          <Line
            type="monotone"
            dataKey="equity"
            stroke="#d90429"          // Harbour Nest red
            strokeWidth={3}
            dot={false}
            activeDot={{ r: 6 }}
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
}
